import M from "./card-manager.js";
import r from "../managers/braze-instance.js";
var G = {
  i: !1,
  aa: null,
  ea: function ea() {
    return G.t(), G.aa || (G.aa = new M(r.p())), G.aa;
  },
  t: function t() {
    G.i || (r.g(G), G.i = !0);
  },
  destroy: function destroy() {
    G.aa = null, G.i = !1;
  }
};
export default G;